// src/screens/customer/customerPannel/customRequests/CustomRequests.jsx

import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ImageIcon,
  Filter,
  Clock,
  CheckCircle,
  XCircle,
  AlertCircle,
  ChevronRight,
  Tag,
} from "lucide-react";
import "../../../../assets/css/customer/customerPannel/customrequests/CustomRequests.css";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
// ─────────────────────────────────────────────────────────────
// DUMMY DATA
// ─────────────────────────────────────────────────────────────
// const allRequests = [
//   {
//     id: "CR-001",
//     furnitureType: "Sofa",
//     description:
//       "3-seater L-shaped sofa in dark grey fabric with wooden legs. Need it to fit a 12x10 ft living room.",
//     submittedAt: "2025-06-01T10:30:00",
//     status: "quoted",
//     quotedPrice: 85000,
//     referenceImages: [
//       "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400",
//       "https://images.unsplash.com/photo-1567016432779-094069958ea5?w=400",
//     ],
//   },
//   {
//     id: "CR-002",
//     furnitureType: "Dining Table",
//     description:
//       "6-seater dining table in solid sheesham wood, natural finish. Dimensions: 6ft x 3ft.",
//     submittedAt: "2025-06-05T14:00:00",
//     status: "pending",
//     quotedPrice: null,
//     referenceImages: [
//       "https://images.unsplash.com/photo-1617806118233-18e1de247200?w=400",
//     ],
//   },
//   {
//     id: "CR-003",
//     furnitureType: "Wardrobe",
//     description:
//       "4-door sliding wardrobe with mirror panels and internal shelving. White finish.",
//     submittedAt: "2025-05-20T09:15:00",
//     status: "accepted",
//     quotedPrice: 120000,
//     referenceImages: [
//       "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400",
//     ],
//   },
//   {
//     id: "CR-004",
//     furnitureType: "Bed Frame",
//     description:
//       "King-size bed frame with upholstered headboard in beige fabric. Storage drawers underneath.",
//     submittedAt: "2025-05-10T11:00:00",
//     status: "rejected",
//     quotedPrice: null,
//     referenceImages: [
//       "https://images.unsplash.com/photo-1505693314120-0d443867891c?w=400",
//     ],
//   },
//   {
//     id: "CR-005",
//     furnitureType: "Bookshelf",
//     description:
//       "Floor-to-ceiling bookshelf with ladder, walnut finish, adjustable shelves.",
//     submittedAt: "2025-06-08T16:45:00",
//     status: "pending",
//     quotedPrice: null,
//     referenceImages: [
//       "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
//     ],
//   },
// ];

// ─────────────────────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────────────────────
const STATUS_CONFIG = {
  pending: {
    label: "Awaiting Quote",
    color: "#b45309",
    bg: "rgba(234,179,8,0.1)",
    icon: Clock,
  },
  quoted: {
    label: "Quote Received",
    color: "#2563eb",
    bg: "rgba(37,99,235,0.1)",
    icon: Tag,
  },
  accepted: {
    label: "Accepted",
    color: "#16a34a",
    bg: "rgba(22,163,74,0.1)",
    icon: CheckCircle,
  },
  rejected: {
    label: "Rejected",
    color: "#dc2626",
    bg: "rgba(220,38,38,0.1)",
    icon: XCircle,
  },
};

const FILTER_OPTIONS = [
  { value: "all", label: "All Requests" },
  { value: "pending", label: "Awaiting Quote" },
  { value: "quoted", label: "Quote Received" },
  { value: "accepted", label: "Accepted" },
  { value: "rejected", label: "Rejected" },
];

// ─────────────────────────────────────────────────────────────
// STATUS BADGE
// ─────────────────────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = cfg.icon;
  return (
    <span
      className="cr-status-badge"
      style={{ color: cfg.color, background: cfg.bg }}
    >
      <Icon size={11} strokeWidth={2.5} />
      {cfg.label}
    </span>
  );
};

// ─────────────────────────────────────────────────────────────
// REQUEST CARD
// ─────────────────────────────────────────────────────────────
const RequestCard = ({ req }) => {
  const { baseUrlForFile } = useContext(AppContext);
  const firstImage = req.custom_cart_images?.[0];
  console.log(firstImage);

  return (
    <div className="cr-card">
      {/* Image strip */}
      <div className="cr-card-img-wrap">
        {firstImage ? (
          <img
            src={`${baseUrlForFile}/${firstImage.image_path}`}
            alt={req.adproduct.name}
            className="cr-card-img"
          />
        ) : (
          <div className="cr-card-img-placeholder">
            <ImageIcon size={28} strokeWidth={1.5} />
          </div>
        )}
        {req.custom_cart_images?.length > 1 && (
          <span className="cr-img-count">
            +{req.custom_cart_images.length - 1}
          </span>
        )}
      </div>

      {/* Body */}
      <div className="cr-card-body">
        <div className="cr-card-top">
          <div>
            <p className="cr-card-type">{req.adproduct.name}</p>
            <p className="cr-card-id">{req.id}</p>
          </div>
          <StatusBadge status={req.status} />
        </div>

        <p className="cr-card-desc">{req.description}</p>

        <div className="cr-card-footer">
          <div className="cr-card-meta">
            <span className="cr-card-date">
              {new Date(req.created_at).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </span>
            {req.quotedPrice && (
              <span className="cr-card-price">
                PKR {req.quotedPrice.toLocaleString()}
              </span>
            )}
          </div>
          <Link
            to={`/customer/custom-requests/${req.id}`}
            className="cr-view-btn"
          >
            View <ChevronRight size={13} strokeWidth={2.5} />
          </Link>
        </div>

        {/* Quote action hint */}
        {req.status === "quoted" && (
          <div className="cr-quote-hint">
            <AlertCircle size={12} strokeWidth={2} />
            Quote received — review and respond
          </div>
        )}
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────
const CustomRequests = () => {
  const { authToken, baseUrl, loggedInCustomer } = useContext(AppContext);
  const [filter, setFilter] = useState("all");
  const [allRequests, setAllRequests] = useState([]);

  useEffect(() => {
    viewMyRequests();
  }, []);

  const filtered =
    filter === "all"
      ? allRequests
      : allRequests.filter((r) => r.status === filter);

  const countByStatus = (s) => allRequests.filter((r) => r.status === s).length;

  const viewMyRequests = () => {
    const formData = new FormData();
    formData.append("adcustomer_id", loggedInCustomer?.id);

    axios
      .post(`${baseUrl}/customer/cart/showCustomRequests`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log(response.data);
        setAllRequests(response.data.cart);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="cr-page">
      {/* ── Header ── */}
      <div className="cr-header">
        <div>
          <h1 className="cr-title">Custom Requests</h1>
          <p className="cr-subtitle">
            Track all your furniture custom requests
          </p>
        </div>
        <div className="cr-stats">
          <div className="cr-stat">
            <span className="cr-stat-num">{allRequests.length}</span>
            <span className="cr-stat-lbl">Total</span>
          </div>
          <div className="cr-stat cr-stat--blue">
            <span className="cr-stat-num">{countByStatus("quoted")}</span>
            <span className="cr-stat-lbl">Quoted</span>
          </div>
          <div className="cr-stat cr-stat--yellow">
            <span className="cr-stat-num">{countByStatus("pending")}</span>
            <span className="cr-stat-lbl">Pending</span>
          </div>
        </div>
      </div>

      {/* ── Filter ── */}
      <div className="cr-filter-bar">
        {FILTER_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            className={`cr-filter-btn ${filter === opt.value ? "cr-filter-btn--active" : ""}`}
            onClick={() => setFilter(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {/* ── Cards Grid ── */}
      {filtered.length === 0 ? (
        <div className="cr-empty">
          <ImageIcon
            size={44}
            strokeWidth={1.2}
            color="#D67E43"
            style={{ opacity: 0.45 }}
          />
          <h3>No Requests Found</h3>
          <p>No custom requests match this filter.</p>
        </div>
      ) : (
        <>
          <div className="cr-grid">
            {filtered.map((req) => (
              <RequestCard key={req.id} req={req} />
            ))}
          </div>
          <p className="cr-results-txt">
            Showing <strong>{filtered.length}</strong> of{" "}
            <strong>{allRequests.length}</strong> requests
          </p>
        </>
      )}
    </div>
  );
};

export default CustomRequests;
